import { Avatar, HStack, SuitabilityBadge, Text, VStack } from '@genial/components';
import React from 'react';

import { CustomerV4FinancialResponseNormalized } from '../../../../../store/customer/types';
import { DoubleTextSkeleton } from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export declare namespace CustomerNameTypes {
  export interface Props {
    customer: CustomerV4FinancialResponseNormalized;
  }
}

export const CustomerName: React.FC<CustomerNameTypes.Props> = ({ customer }) => (
  <HStack alignItems="center" space="stack.nano">
    <SuitabilityBadge label={customer.suitabilityLabelNormalized} hideText />
    <VStack space="stack.quarck" flex={1}>
      <Text variant="bold" color="neutral.darkest">
        {customer.customerNameNormalized}
      </Text>
      {customer.email && (
        <Text fontSize="xs" color="neutral.medium">
          {customer.email}
        </Text>
      )}
    </VStack>
  </HStack>
);

export const CustomerNameLoading: React.FC = () => (
  <HStack alignItems="center" space="stack.nano">
    <Avatar
      testId="avatar"
      isLoading
      bgColor="backgroundlight"
      initials="LO"
      textColor="background"
    />
    <VStack space="stack.quarck" flex={1}>
      <DoubleTextSkeleton />
    </VStack>
  </HStack>
);
